import * as React from 'react'
import { Chip, Box } from '@mui/material'
import { formatDate } from "@ui-seeker/utils"


export default function releaseColumn() {
    return[ {
        name: 'newRelease', label: 'New Release',
        options: {
            display: 'excluded',
            customBodyRowRender: v => v ? 'Yes' : 'No'
        }
    }, {
        name: 'releaseDate', label: 'Release Date',
        options: {
            filter: false,
            customBodyRowRender: (value, {newRelease}) => <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {formatDate(value, {isString: true})}
                { newRelease && <Chip label='New Release' style={{ backgroundColor: 'green', color: 'white' }} />}
            </Box> 
        }
    }]
}
